module.exports = __webpack_public_path__ + "static/middle-9e4de3dcff9f6404ca6a117007f31324.svg";